import { profile } from "../data/portfolio";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="footer">
      <p>
        © {year} {profile.name}. All rights reserved.
      </p>
      <div className="footer-links">
        <a href={profile.social.linkedin} target="_blank" rel="noopener noreferrer">
          LinkedIn
        </a>
        <a href={profile.social.scholar} target="_blank" rel="noopener noreferrer">
          Scholar
        </a>
        <a href={profile.social.instagram} target="_blank" rel="noopener noreferrer">
          Instagram
        </a>
      </div>
    </footer>
  );
}
